import { render } from "./GuardianThreadList.vue?vue&type=template&id=b95022e8&scoped=true"
import script from "./GuardianThreadList.vue?vue&type=script&lang=js"
export * from "./GuardianThreadList.vue?vue&type=script&lang=js"

import "./GuardianThreadList.vue?vue&type=style&index=0&id=b95022e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b95022e8"]])

export default __exports__